export const maximumNumberOfImages = 6;
export const maxImagesReached =
  ' You have reached the maximum number of images, and can thereby not add any more.';
